<div class="flex flex-col justify-center px-3 md:px-4">
  @if (event() && moodImageData()) {
    <div class="relative header-image mb-3 md:mb-5">
      <app-progressive-image
        [imageData]="moodImageData()"
        [imageClasses]="'w-full rounded-2xl object-cover max-h-32 md:max-h-48'"
        [loadingStrategy]="'eager'"
        [fetchPriority]="'high'">
        <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent rounded-2xl"></div>
        <div class="absolute bottom-0 left-0 right-0 p-3 md:p-4">
          <div class="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2 sm:gap-4">
            @if (eventLocation()) {
              <div class="flex items-center gap-2">
                <lucide-angular
                  [img]="mapPin"
                  class="text-white flex-shrink-0"
                  [attr.size]="16"
                ></lucide-angular>
                <span class="text-white font-bold text-sm md:text-base drop-shadow-sm">{{ eventLocation() }}</span>
              </div>
            }

            @if (eventStartDate()) {
              <div class="flex items-center gap-2">
                <lucide-angular
                  [img]="events"
                  class="text-white flex-shrink-0"
                  [attr.size]="16"
                ></lucide-angular>
                <span class="text-white font-bold text-sm md:text-base drop-shadow-sm">
                  {{ eventDateCompact() }}
                </span>
              </div>
            }
          </div>
        </div>
      </app-progressive-image>
    </div>
  }

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
    <div class="space-y-3 md:space-y-4"
         [style.display]="hasUpdates ? null : 'none'">
      <app-updates
        [cardClasses]="'mb-3 md:mb-4 p-3 md:p-4'"
        [compact]="true"
        [eventDocumentId]="eventDocumentId"
        [showCard]="true"
        [showExpandCollapse]="true"
        (hasUpdates)="hasUpdates = $event">
      </app-updates>

      @if (phoneNumbers().length > 0) {
        <app-shared-card additionalClasses="p-3 md:p-4">
          <div class="space-y-3 md:space-y-4">
            <h3 class="text-lg md:text-xl font-semibold text-gray-800">
              Wichtige Telefonnummern
            </h3>
            <div class="space-y-2 md:space-y-3">
              @for (phoneNumber of phoneNumbers(); track phoneNumber.title) {
                <div class="flex justify-between items-center">
                  <span class="text-gray-700 text-sm md:text-base">{{ phoneNumber.title }}</span>
                  <a
                    href="tel:{{ phoneNumber.phoneNumber }}"
                    class="text-gray-700 font-medium underline hover:underline text-sm md:text-base"
                  >
                    {{ phoneNumber.phoneNumber }}
                  </a>
                </div>
              }
            </div>
          </div>
        </app-shared-card>
      }
    </div>

    @if (travelInformation()) {
      <app-shared-card additionalClasses="p-3 md:p-4">
        <div class="space-y-3 md:space-y-4">
          <h3 class="text-lg md:text-xl font-semibold text-gray-800">
            Informationen zur An- und Abreise
          </h3>

          <app-markdown-card [markdownString]="travelInformation()"></app-markdown-card>
        </div>
      </app-shared-card>
    }

    @if (!!event() && eventHasLinks(event()!)) {
      @for (link of getEventLinks(event()!); track link) {
        <app-link-box
          class="mb-3"
          [title]="link.title"
          [url]="link.url"
          [icon]="link.icon">
        </app-link-box>
      }
    }
  </div>
</div>
